import { render, staticRenderFns } from "./Personnalize.vue?vue&type=template&id=18829324&"
import script from "./Personnalize.vue?vue&type=script&lang=js&"
export * from "./Personnalize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports